import Vue from 'vue'

const state = {
  channels: []
}

const mutations = {
  setChannels (state, data) {
    for (let channel of data) {
      channel.writingParticipant = null
      let newMsg = JSON.parse(JSON.stringify(data.rootState.message.newMessageModel))
      Vue.set(channel, 'newMessage', newMsg)

      let uploaders = JSON.parse(JSON.stringify(data.rootState.message.uploadersModel))
      Vue.set(channel, 'uploaders', uploaders)

      let preview = JSON.parse(JSON.stringify(data.rootState.message.previewModel))
      Vue.set(channel, 'preview', preview)
    }

    for (const iterator of data.rootState.conversation.clearedConversations) {
      if (iterator.isRemove === true) {
        let item = data.find(x => x.ChannelID === iterator.UniqueID && new Date(x.CreateDate).getTime() <= new Date(iterator.ClearDate).getTime())
        let i = data.indexOf(item)
        if (i !== -1) {
          let filteredMessages = data.rootState.message.messages.filter(x => x.To === iterator.UniqueID)
          if (filteredMessages.length === 0) {
            data.splice(i, 1)
          }
        }
      } else {
        let item2 = data.find(x => x.ChannelID === iterator.UniqueID && new Date(x.CreateDate).getTime() <= new Date(iterator.ClearDate).getTime())
        if (item2) {
          item2.LastMessage = {}
        }
      }
    }

    state.channels = data
    let activeConversationID = data.rootState.conversation.activeConversation && data.rootState.conversation.activeConversation.ConversationID
    if (activeConversationID) {
      let activeChannel = state.channels.find(x => x.ChannelID === activeConversationID)
      if (activeChannel) {
        data.rootState.conversation.activeConversation = activeChannel
      }
    }
  },

  appendChannel (state, data) {
    data.writingParticipant = null
    let newMsg = JSON.parse(JSON.stringify(data.rootState.message.newMessageModel))
    Vue.set(data, 'newMessage', newMsg)

    let uploaders = JSON.parse(JSON.stringify(data.rootState.message.uploadersModel))
    Vue.set(data, 'uploaders', uploaders)

    let preview = JSON.parse(JSON.stringify(data.rootState.message.previewModel))
    Vue.set(data, 'preview', preview)

    let currentIndex = state.channels.findIndex(x => x.ChannelID === data.ChannelID)
    if (currentIndex >= 0) {
      Vue.set(state.channels, currentIndex, data)
      return
    }

    state.channels.push(data)
  }
}

const actions = {
  setChannels (context, data) {
    data.rootState = context.rootState
    context.commit('setChannels', data)
  },

  appendChannel (context, data) {
    data.rootState = context.rootState
    context.commit('appendChannel', data)
  }
}

export default {
  state,
  mutations,
  actions
}
